<template>
    <transition name="modal-fade">
        <div class="modal-backdrop-new">
            <div
              role="dialog"
              aria-modal="true"
              class="ckyc-modal"
              aria-labelledby="ckyc-modal-title"
            >
              <div class="ckyc-modal__content">
                <b-card class="ckyc-modal__card">
                  <button
                    type="button"
                    class="ckyc-modal__close btn-close"
                    @click="close"
                    aria-label="Close modal"
                  >
                    <img
                      src="https://storage.googleapis.com/mscms/img/closeBlack.png"
                      alt=""
                      class="ckyc-modal__close-icon"
                    />
                  </button>
                  <iframe
                    ref="kycFrame"
                    class="ckyc-modal__iframe"
                    :src="href"
                    title="CKYC verification"
                    :scrolling="allowIframeScroll ? 'yes' : 'no'"
                    :style="iframeStyle"
                    @load="resizeIframe"
                  ></iframe>
                </b-card>
              </div>
            </div>
        </div>
    </transition>
</template>

<style scoped>
.ckyc-modal__content {
    width: auto;
    height: auto;
    max-height: none;
    overflow: visible;
}

.ckyc-modal__card {
    position: relative;
}

.ckyc-modal__close {
    position: absolute;
    top: 8px;
    right: 10px;
    z-index: 2;
    padding: 0;
    border: none;
    line-height: 0;
    background: transparent;
    cursor: pointer;
}

.ckyc-modal__close-icon {
    width: 20px;
    height: 20px;
    display: block;
}

.ckyc-modal__iframe {
    width: 400px;
    max-width: calc(100vw - 2rem);
    border: 0;
    display: block;
    border-radius: 40px;
    pointer-events: auto;
    touch-action: manipulation;
}

.ckyc-modal__card,
.ckyc-modal__content {
    pointer-events: auto;
}

@media (max-width: 767px) {
  .ckyc-modal__iframe {
    width: calc(100vw - 2rem);
    max-width: 100%;
    border-radius: 24px;
  }

  .ckyc-modal__close {
    top: 4px;
    right: 6px;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.card-body {
    padding: 0;
}
</style>

<script>

  export default {
    name: "ckycmodal",
    props: {
      cancelModal: { type: Function, required: true },
      href: { type: String, default: "" },
      onContinue: { type: Function, default: null },
    },
    data() {
      return {
        iframeHeight: '',
        allowIframeScroll: typeof window !== "undefined" && window.innerWidth <= 767,
      };
    },

    computed: {
      iframeStyle() {
        const height = Number(this.iframeHeight);
        return {
          height: `${height > 0 ? height : 1}px`,
        };
      },
    },

    mounted() {
      window.addEventListener("message", this.handleIframeMessage);
      window.addEventListener("resize", this.updateIframeScrollMode);
      this.updateIframeScrollMode();
    },

    beforeDestroy() {
      window.removeEventListener("message", this.handleIframeMessage);
      window.removeEventListener("resize", this.updateIframeScrollMode);
    },

    methods: {
      updateIframeScrollMode() {
        this.allowIframeScroll = window.innerWidth <= 767;
      },

      close() {
        this.cancelModal();
      },

      handleIframeMessage(event) {
        const data = event.data;

        if (data === "popbacktoprevious") {
          this.closeAndContinue({ action: "popbacktoprevious" });
          return;
        }

        if (!data || typeof data !== "object") return;

        if (data.type === "resize") {
          const height = data.height || data.frameHeight || data.value;
          if (height && Number(height) > 0) {
            this.iframeHeight = Number(height);
          }
          return;
        }

        const shouldContinue =
          data.type === "continueCkyc" ||
          data.type === "popbacktoprevious" ||
          data.action === "continueCkyc" ||
          data.action === "popbacktoprevious" ||
          data.reload === true ||
          data.closeModal === true;

        if (shouldContinue) {
          this.closeAndContinue(data);
        }
      },

      closeAndContinue(data) {
        if (typeof this.onContinue === "function") {
          this.onContinue(data);
          return;
        }

        this.cancelModal();

        const returnUrl = data && data.returnUrl ? String(data.returnUrl).trim() : "";
        const isPopBack =
          !returnUrl ||
          returnUrl.toLowerCase() === "popbacktoprevious" ||
          data.action === "popbacktoprevious" ||
          data.type === "popbacktoprevious";

        if (!isPopBack) {
          try {
            const target = new URL(returnUrl, window.location.origin);
            const current = new URL(window.location.href);

            if (target.origin === current.origin) {
              const targetPath = `${target.pathname}${target.search}${target.hash}`;
              const currentPath = `${current.pathname}${current.search}${current.hash}`;

              if (targetPath === currentPath) {
                this.reloadCurrentPage();
              } else {
                window.location.href = target.href;
              }
              return;
            }
          } catch {
            /* fall through to reload */
          }
        }

        this.reloadCurrentPage();
      },

      reloadCurrentPage() {
        try {
          const url = new URL(window.location.href);
          if (url.searchParams.has("_ckyc")) {
            url.searchParams.delete("_ckyc");
            window.location.replace(url.href);
            return;
          }
        } catch {
          /* ignore */
        }

        window.location.reload();
      },

      closeAndReload() {
        this.cancelModal();
        this.reloadCurrentPage();
      },

      resizeIframe() {
        const iframe = this.$refs.kycFrame;
        if (!iframe) return;

        try {
          const doc = iframe.contentWindow.document;
          const height = Math.max(
            doc.body.scrollHeight,
            doc.documentElement.scrollHeight
          );

          if (height > 0) {
            this.iframeHeight = height;
          }
        } catch (e) {
          // Cross-origin iframe: height will be set via postMessage from the embedded app.
        }
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Dialogs/CKYCModal.vue